module.exports = __webpack_public_path__ + "static/media/example-3.fb7ccf61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/BushfireFront/example-3.jpg
// module id = 199
// module chunks = 0